export default __webpack_public_path__ + "static/media/ringing.69add2c1.mp3";